import React, { Component } from 'react';
import SeriesTitle from 'react/views/series/SeriesTitle';
import CarouselHeader from 'react/views/carousel/CarouselHeader';
import SeriesEventTypes from '../../../data/types/SeriesEventTypes';
import MeasuredCarouselView from 'react/views/carousel/MeasuredCarouselView';
import { CarouselItemWidth } from 'react/views/carousel/CarouselItem';
import LinkToNoveList from 'react/views/generic/LinkToNoveList';

class BooksInSeriesView extends Component {
	renderBooks() {
		const seriesTitles = this.props.cardModel.map((title) => {
			return (
				<SeriesTitle
					key={title.uniqueId}
					title={title}
					jacketClickEvent={SeriesEventTypes.SERIES_COVER_CLICKED}
					titleClickEvent={SeriesEventTypes.SERIES_TITLE_CLICKED}
					otsFindItEvent={SeriesEventTypes.SERIES_FINDIT_CLICKED}
					otsClickEvent={SeriesEventTypes.SERIES_AVAILABILITY_CLICKED}
					otsEnabled={this.props.otsEnabled}
				/>
			);
		});
		return seriesTitles;
	}

	renderHeader() {
		return (
			<div>
				<CarouselHeader
					headerText={this.props.seriesInfo.title}
					headerTagline={this.props.seriesInfo.alternateTitle}
				>
					{this.renderLinkToNoveList()}
				</CarouselHeader>
			</div>
		);
	}

	renderFooter() {
		return (
			<div className='series-note'>{this.props.seriesInfo.seriesNote}</div>
		);
	}

	renderLinkToNoveList() {
		if (this.props.seriesInfo.linkToSeriesInNoveList) {
			return (
				<LinkToNoveList
					href={this.props.seriesInfo.linkToSeriesInNoveList}
					featureType={SeriesEventTypes.SERIES_NOVELISTSERIESNAME_CLICKED}
					destId={this.props.seriesInfo.ui}
					srcId={this.props.srcId}
					displayText={"View this series in NoveList"}
					link
				/>
			);
		}
	}

	render() {
		return (
			<MeasuredCarouselView
				header={this.renderHeader()}
				items={this.renderBooks()}
				footer={this.renderFooter()}
				itemWidth={CarouselItemWidth}
			/>
		);
	}
}

export default BooksInSeriesView;



// WEBPACK FOOTER //
// ./src/react/views/booksInSeries/BooksInSeriesView.jsx